import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { BcClientListService } from './service/bc-client-list.service';
import { saveAs } from 'file-saver';

export interface AlertModel {
  obj;
}

@Component({
  selector: 'app-bc-client-list',
  templateUrl: './bc-client-list.component.html',
  styleUrls: ['./bc-client-list.component.scss'],
  providers:[BcClientListService]
})
export class BcClientListComponent extends DialogComponent<AlertModel, boolean> implements AlertModel, OnInit {

  obj;
  private clients;
  private clientList;

  // Pagination Controls
  private resultCount = 0;
  private currentPage = 0;
  private sort = "desc";
  private orderBy = "Valor";
  private qtdPorPaginaCustom: number = 10;
  private qtdPorPagina = 10;

  constructor(dialogService: DialogService,
              private bcClientListService: BcClientListService) {
    super(dialogService);
  }

  ngOnInit() {
    this.getClientList();
  }

  changePerPage() {
    this.qtdPorPagina = this.qtdPorPaginaCustom;
    this.currentPage = 0;
    this.getClientList();
	}

  getClientList(){
    this.bcClientListService.getClientList(this.obj,this.orderBy,this.sort, this.currentPage, this.qtdPorPaginaCustom).subscribe(result => {
      if (result.Success){
        if (result.Result){
          this.clients = result.Result;     
          if (result.Result.Clientes){
            this.clientList = result.Result.Clientes;
            this.resultCount = result.Result.QuantidadeTotal;
          }
        }
      } else {
        console.log("Erro ao carregar lista de usuários");
      }
    }, error => {
      console.log(error);			
    });
  }

  setOrder(orderby) {
		if (this.orderBy != orderby) {
      this.sort = "asc";
      this.orderBy = orderby;
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc";
		}
		this.getClientList();
  }

  exportExcel() {
    this.bcClientListService.exportClientExcel(this.obj).subscribe(blob => {
        if (blob) {
            saveAs(blob, "lista_de_clientes.xlsx");
        } else {
            console.log("something went wrong!");
        }
    }, error => {
        console.log(error);
    });
  }

  paginar($event: any) {
		this.currentPage = $event;
		this.getClientList();
	}

  confirm() {
    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-client-list/bc-client-list.component.ts